/* Выбор объекта на телефоне. Поиск и дивизионы закреплены сверху,
   плитки прокручиваются под ними. */
.picker {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.controls {
  flex-shrink: 0;
  padding: 16px 16px 10px;
  border-bottom: 1px solid var(--border);
}

.headRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 650;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: var(--text);
}

.hint {
  margin: 2px 0 0;
  font-size: 13.5px;
  color: var(--text2);
}

.close {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 36px;
  height: 36px;
  color: var(--text2);
  background: var(--table-even);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}

/* ── Поиск ── */
.search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  margin-top: 14px;
  padding: 0 12px;
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.search:focus-within {
  border-color: var(--blue);
}

.searchIcon {
  flex-shrink: 0;
  color: var(--text2);
}

.search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  font-size: 16px; /* меньше 16px — iOS увеличивает страницу при вводе */
  color: var(--text);
  background: none;
  border: none;
  outline: none;
}

/* ── Дивизионы ── */
.chips {
  display: flex;
  gap: 8px;
  margin: 12px -16px 0;
  padding: 0 16px 2px;
  overflow-x: auto;
  scrollbar-width: none;
}

.chips::-webkit-scrollbar {
  display: none;
}

.chip {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.chipCount {
  font-size: 12.5px;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.chipOn {
  color: var(--blue);
  background: var(--blue-lt);
  border-color: color-mix(in srgb, var(--blue) 40%, transparent);
}

.chipOn .chipCount {
  color: inherit;
}

:global(html.dark) .chipOn {
  color: var(--navy-accent);
}

/* ── Плитки ── */
.body {
  flex: 1;
  min-height: 0;
  padding: 4px 16px 24px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.section {
  margin-top: 18px;
}

.sectionTitle {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2);
}

.sectionCount {
  font-weight: 400;
  font-variant-numeric: tabular-nums;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}

.recent {
  display: flex;
  gap: 10px;
  margin: 0 -16px;
  padding: 0 16px 4px;
  overflow-x: auto;
  scrollbar-width: none;
}

.recent::-webkit-scrollbar {
  display: none;
}

.tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 12px 14px 12px;
  text-align: left;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 14px;
  cursor: pointer;
  transition:
    border-color 0.12s,
    transform 0.12s;
  -webkit-tap-highlight-color: transparent;
}

.tile:active {
  transform: scale(0.98);
}
.tile:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}

.tileSmall {
  flex: 0 0 168px;
}

.tileSelected {
  border-color: var(--blue);
  box-shadow: inset 0 0 0 1px var(--blue);
}

.tileName {
  overflow: hidden;
  font-size: 17px;
  font-weight: 650;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.tileMeta {
  font-size: 13px;
  color: var(--text2);
}

.bar {
  display: flex;
  gap: 2px;
  height: 6px;
  margin-top: 6px;
  overflow: hidden;
  background: var(--table-even);
  border-radius: 3px;
}

.segClean {
  background: var(--led-clean);
}
.segChecked {
  background: var(--led-checked);
}
.segOpen {
  background: var(--led-open);
}

.tileStatus {
  overflow: hidden;
  font-size: 12.5px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toneOpen {
  color: var(--err);
}
.toneChecked {
  color: var(--text2);
}
.toneClean {
  color: var(--ok);
}

.none {
  padding: 32px 8px;
  text-align: center;
}

.noneTitle {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}
.none p {
  margin: 6px 0 0;
  font-size: 14px;
  color: var(--text2);
}

@media (prefers-reduced-motion: reduce) {
  .tile {
    transition: none;
  }
  .tile:active {
    transform: none;
  }
}
